document.addEventListener('alpine:init', () => {
  Alpine.data('xFiltersAndSortBy', (sectionId, filterType, isSearchPage, isExpanded) => ({
    t: '',
    isShow: false,
    showFilterAside: true,
    isLoading: false,
    isDesktop: false,
    listLayout: true,
    cachedResults: {},
    additionalSearchParams: "",
    sortOption: "",
    searchParamsPrev: window.location.search.slice(1),
    searchParamsInitial: window.location.search.slice(1),
    init() {
      // [FIX] savedLayout === 'grid' のときのみ grid、それ以外は list（未保存・'list'・null すべて list）
      const savedLayout = localStorage.getItem(`${FACET.productLayout}`);
      if (savedLayout === 'grid') {
        this.listLayout = false;
      } else {
        this.listLayout = true;
      }

      Alpine.nextTick(() => {
        this._initLayout();
      })
      this._setListeners();

      installMediaQueryWatcher("(min-width: 768px)", (matches) => {
        if (matches) {
          if (filterType != 'drawer') {
            this.isShow = false;
            Alpine.store("xMaximizeDrawer").handleClose();
          }
          this.isDesktop = true;
        } else {
          this.isDesktop = false;
        }
      });

      if (isSearchPage) {
        this.isSearchPage = isSearchPage
        this.additionalSearchParams = "type=product";
      }

      // search.filters が空（.facet-filter-wrapper が存在しない）場合、一度だけリロード
if (isSearchPage) {
  const delays = [400, 800, 1500, 2500, 4000];

  const tryFetch = (attempt) => {
    if (attempt >= delays.length) return;

    setTimeout(() => {
      if (document.querySelector('.facet-filter-wrapper .js-filter')) return;

      const currentParams = new URLSearchParams(window.location.search);
      const sectionUrl = `${window.location.pathname}?section_id=${sectionId}&type=product&${currentParams.toString()}`;

      fetch(sectionUrl, { cache: 'no-store' })
        .then(r => r.text())
        .then(html => {
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          if (parsed.querySelector('.js-filter')) {
            const newAside = parsed.querySelector('.form-aside');
            const newDrawer = parsed.querySelector('.form-drawer');
            const newBar = parsed.getElementById('FacetsWrapperBar');

            const currentAside = document.querySelector('.form-aside');
            const currentDrawer = document.querySelector('.form-drawer');
            const currentBar = document.getElementById('FacetsWrapperBar');

            if (currentAside && newAside) currentAside.innerHTML = newAside.innerHTML;
            if (currentDrawer && newDrawer) currentDrawer.innerHTML = newDrawer.innerHTML;
            if (currentBar && newBar) currentBar.innerHTML = newBar.innerHTML;

                          // [追加] aside レイアウトの親flexクラスを付与して横並びにする
  const layoutWrapper = document.querySelector('#ProductGridContainer')?.parentElement;
  if (layoutWrapper && filterType === 'aside') {
    layoutWrapper.classList.add('flex', 'flex-col', 'md:flex-row', 'md:gap-7.5');
  }

  // [追加] _initLayout を再実行してFacetFiltersFormのidを正しく設定
  this._initLayout();
  
          } else {
            tryFetch(attempt + 1);
          }
        })
        .catch(() => tryFetch(attempt + 1));
    }, delays[attempt]);
  };

  tryFetch(0);
}

    },
    _initLayout() {
      let formAside = document.getElementsByClassName('form-aside')[0] || null;
      let formDrawer = document.getElementsByClassName('form-drawer')[0] || null;
      if (window.innerWidth >= MIN_DEVICE_WIDTH.tablet) {
        this.isDesktop = true;
        if (formAside) {
          formAside.setAttribute('id','FacetFiltersForm');
          if (formDrawer) formDrawer.removeAttribute('id');
        } else {
          if (formDrawer) formDrawer.setAttribute('id','FacetFiltersForm');
        }
      } else {
        this.isDesktop = false;
        if (formAside) formAside.removeAttribute('id');
        if (formDrawer) formDrawer.setAttribute('id','FacetFiltersForm');
      }
    },
    _setListeners() {
      const onHistoryChange = (event) => {
        const searchParams = event.state ? event.state.searchParams : this.searchParamsInitial;
        if (searchParams === this.searchParamsPrev) return;
        this._renderPage(searchParams, false);
      }
      window.addEventListener('popstate', onHistoryChange);

      installMediaQueryWatcher('(min-width: 768px)', this._initLayout);

      document.addEventListener(SELECT_ELEMENT_EVENT.change, (event) => {
        let sortByOption = event.target;
        if (sortByOption.classList.contains('sorting-option'))
          this.onSubmit(0);
      });
    },
    toggleLayout(theBoolean) {
      this.listLayout = theBoolean;
      localStorage.setItem(`${FACET.productLayout}`, theBoolean ? "list" : "grid");
      // レイアウト変更後にリサイズイベントを発火（Sliderなどの再計算用）
      setTimeout(() => {
        window.dispatchEvent(new CustomEvent('resize', { detail: { isChangeLayoutMode: true } }));
      }, 300)
    },
    removeFilter(url) {
      let removeUrl = url
      if (this.isSearchPage) {
        removeUrl = `${url}&${this.additionalSearchParams}`
      }
      this._reloadFilter(removeUrl);
    },
    onSubmit(wait = 500) {
      if (this.t) {
        clearTimeout(this.t);
      }

      const func = () => {
        const searchParams = this._createSearchParams(document.getElementById('FacetFiltersForm'));
        this._renderPage(searchParams);
        if (this.isDesktop) {
          document.getElementById('SelectSortByOption').blur();
          const sectionWrapperEle = document.getElementById(sectionId);
          if (sectionWrapperEle) {
            sectionWrapperEle.scrollIntoView({ behavior: 'smooth' });
          }
        }
      }
      
      this.t = setTimeout(() => {
        func();
      }, wait);
    },

    _reloadFilter(url) {
      const searchParams = url.indexOf('?') == -1 ? '' : url.slice(url.indexOf('?') + 1);
      this._renderPage(searchParams);
    },
    _createSearchParams(form) {
      const formData = new FormData(form);
      return new URLSearchParams(formData).toString();
    },
    _getPerPage() {
      return new URLSearchParams(window.location.search).get('per_page') || '';
    },
    _updateURLHash(searchParams) {
      const perPage = this._getPerPage();
      let params = new URLSearchParams(searchParams);
      if (perPage) params.set('per_page', perPage);
      const finalParams = params.toString();
      history.pushState({ searchParams: finalParams }, '', `${window.location.pathname}${finalParams ? '?' + finalParams : ''}`);
    },
    _showLoadingCover() {
      const cover = document.querySelector('#ProductGridContainer .loading-cover');
      if (cover) cover.style.removeProperty('display');
    },
    _hideLoadingCover() {
      document.querySelectorAll('#ProductGridContainer .loading-cover').forEach(el => {
        el.style.display = 'none';
      });
    },
    async _renderPage(searchParams, updateURLHash = true) {
      this.searchParamsPrev = searchParams;
      this.isLoading = true;
      this._showLoadingCover();

      const perPage = this._getPerPage();
      let params = new URLSearchParams(searchParams);
      if (perPage) params.set('per_page', perPage);
      const searchParamsWithPerPage = params.toString();

      if (this.cachedResults[searchParamsWithPerPage]) {
        this._renderResults(this.cachedResults[searchParamsWithPerPage]);
        if (updateURLHash) {
          this._updateURLHash(searchParams);
        }
        return;
      }

      // [FIX] q= が searchParams に含まれない場合、現在URLのq=を引き継ぐ
      // これがないとShopifyがsearch.performed=falseを返し、フィルター消失・1列崩れが発生する
      let fetchParams = new URLSearchParams(searchParamsWithPerPage);
      if (!fetchParams.has('q')) {
        const currentQ = new URLSearchParams(window.location.search).get('q');
        if (currentQ !== null) fetchParams.set('q', currentQ);
      }
      const url = `${window.location.pathname}?section_id=${sectionId}&${this.additionalSearchParams}&${fetchParams.toString()}`;

      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 15000);

      try {
        const response = await fetch(url, { signal: controller.signal });
        clearTimeout(timeoutId);

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const html = await response.text();
        this.cachedResults[searchParamsWithPerPage] = html;
        this._renderResults(html);
      } catch (error) {
        clearTimeout(timeoutId);
        this.isLoading = false;
        this._hideLoadingCover();
      }

      if (updateURLHash) {
        this._updateURLHash(searchParams);
      }
    },
    _renderResults(html) {
      this._renderFilters(html);
      this._renderProductGridContainer(html);
      this._renderProductCount(html);
      if (this.isSearchPage) {
        this.__renderProductTabButton(html)
      }
      this.isLoading = false;
      this._hideLoadingCover();
    },
    __renderProductTabButton(html) {
      const productCountEl = new DOMParser().parseFromString(html, 'text/html').querySelector('.button-tab-product');
      if (productCountEl) {
        const containerDrawer = document.querySelector('.button-tab-product');
        if (containerDrawer) containerDrawer.innerHTML = productCountEl.innerHTML;
      }
    },
    _renderFilters(html) {
      const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
      let blockFilterDrawer = '.form-drawer';
      let blockFilterAside = '.form-aside';
      const selectblockFilterDrawer = document.querySelector(blockFilterDrawer);
      const selectblockFilterAside = document.querySelector(blockFilterAside);
      const filterWrapper = document.querySelector(".facet-filter-wrapper");
      const filterWrapperToRender = parsedHTML.querySelector(".facet-filter-wrapper")
      const buttonFilterWrapper = document.getElementById('ButtonFilterWrapper');
      if (parsedHTML.querySelector(".js-filter")) {
        if (filterWrapper) filterWrapper.style.display = ""; // null チェック追加
        if (buttonFilterWrapper) {
          buttonFilterWrapper.style.display = "";
        }
        if (selectblockFilterDrawer) {
          if (this.$el.id) {
            const blockFilterDrawerElement = parsedHTML.querySelector(blockFilterDrawer);
            if (blockFilterDrawerElement) {
              blockFilterDrawerElement.querySelectorAll('.js-filter').forEach((element, index) => {
                const filterParam = element.dataset.paramName;
                let currentElement = selectblockFilterDrawer.querySelector(`[data-param-name="${filterParam}"]`);
                if (currentElement) {
                  let isExpanded = currentElement.dataset.expanded == 'true' ? '{open: true}' : '{open: false}';
                  element.setAttribute('x-data', isExpanded);
                }
              });
            }
          }

          const newblockFilterDrawer = parsedHTML.querySelector(blockFilterDrawer);
          if (newblockFilterDrawer) {
            selectblockFilterDrawer.innerHTML = newblockFilterDrawer.innerHTML;
          } else {
            selectblockFilterDrawer.innerHTML = '';
          }
          this._renderAdditionalElements(parsedHTML);
        };
        if (selectblockFilterAside) {
          if (this.$el.id) {
            const blockFilterAsideElement = parsedHTML.querySelector(blockFilterAside);
            if (blockFilterAsideElement) {
              blockFilterAsideElement.querySelectorAll('.js-filter').forEach((element, index) => {
                let isExpanded = '{open: false}';
                const filterParam = element.dataset.paramName;
                let currentElement = selectblockFilterAside.querySelector(`[data-param-name="${filterParam}"]`);
                if (currentElement) {
                  isExpanded = currentElement.dataset.expanded == 'true' ? '{open: true}' : '{open: false}';
                }
                element.setAttribute('x-data', isExpanded);
              });
            }
          }

          const newblockFilterAside = parsedHTML.querySelector(blockFilterAside);
          if (newblockFilterAside) {
            selectblockFilterAside.innerHTML = newblockFilterAside.innerHTML;
          } else {
            selectblockFilterAside.innerHTML = ""
          }
    
          this._renderAdditionalElements(parsedHTML);
        };
        
        const filterTagEl = document.getElementById('ActiveFilterTag');
        const newFilterTagEl = parsedHTML.getElementById('FacetsContainerBar')?.content?.getElementById('ActiveFilterTag');

        if (filterTagEl) {
          if (newFilterTagEl) {
            filterTagEl.innerHTML = newFilterTagEl.innerHTML;
          } else {
            filterTagEl.innerHTML = "";
          }
        }
        const filterWrapperBar = document.getElementById("FacetsWrapperBar");
        if (filterWrapperBar?.dataset.stickyFilter === "true") {
          this.setFilterHeaderHeight();
        }
} else {
  if (filterWrapperToRender && filterWrapperToRender.dataset.showFilter === "false") {
    if (filterWrapper) {
      filterWrapper.classList.add("md:hidden");
      filterWrapper.innerHTML = filterWrapperToRender.innerHTML;
    }
  }
  if (!parsedHTML.querySelector('.facets-filter__wrapper')?.dataset.enableFilter) {
    if (buttonFilterWrapper) buttonFilterWrapper.style.display = "none";
  }
  if (filterType == 'drawer') {
    document.body.classList.remove('overflow-y-hidden');
  }
}
      
      this._renderAdvancedFilters(parsedHTML, "desktop");
      this._renderAdvancedFilters(parsedHTML, "mobile");
      const mobileActiveFilterTag = document.getElementById("mobile-active-filter-tag");
      const renderedMobileFilterTag = parsedHTML.querySelector("#mobile-active-filter-tag");
      if (mobileActiveFilterTag && renderedMobileFilterTag) {
        mobileActiveFilterTag.innerHTML = renderedMobileFilterTag.innerHTML
      }
    },
    _renderAdvancedFilters(html, type) {
      const destination = document.querySelectorAll(`.${type}-advanced-filter`);
      const source = html.querySelectorAll(`.${type}-advanced-filter`);

      if (destination.length > 0) {
        destination.forEach((destination, index) => {
          if (source[index]) {
            destination.innerHTML = source[index].innerHTML;
          } else {
            destination.innerHTML = "";
          }
        })
      }
    },
    _renderProductGridContainer(html) {
      const productGridContainer = document.getElementById('ProductGridContainer');
      const destinationElement = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer')
      
      if (productGridContainer && destinationElement) {
        productGridContainer.innerHTML = destinationElement.innerHTML;
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger();
      }
    },
    _renderProductCount(html) {
      const productCountEl = new DOMParser().parseFromString(html, 'text/html').getElementById('FacetsProductCount');
      if (productCountEl) {
        const count = productCountEl.innerHTML;
        const container = document.getElementById('ProductCount_header');
        const containerDrawer = document.getElementById('ProductCountDrawer');
        if (container) container.innerHTML = count;
        if (containerDrawer) containerDrawer.innerHTML = count;
      }
    },
    _renderAdditionalElements(html) {
      const container = document.getElementById('ProductPerPage');
      const destinationElement = html.getElementById('ProductPerPage')
      if (container && destinationElement) container.innerHTML = destinationElement.innerHTML;
    },
    _filterFocus() {
      Alpine.store('xFocusElement').trapFocus('FacetsFilterDrawer','CloseFilterDrawer');
    },
    _filterRemoveFocus() {
      Alpine.store('xFocusElement').removeTrapFocus();
    },
    setFilterHeaderHeight() {
      const filterWrapperBar = document.getElementById("FacetsWrapperBar")
      document.documentElement.style.setProperty('--height-sticky-filter',filterWrapperBar.getBoundingClientRect().height + "px");
    },
    setPositionOptionFilter(el) {
      let elRect = el.getBoundingClientRect();
      const elPopup = el.getElementsByClassName('popup-above')[0];
      let spacingRight = window.innerWidth - elRect.left;
      let checkSpacing = spacingRight - el.innerWidth;
      if (checkSpacing >= 0) {
        elPopup.style.left = '0px';
      } else {
        elPopup.style.left = checkSpacing+ 'px';
      }
    }
  }));
});